var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBell = function SvgBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M19.246 18.25c.747 0 1.25-.61 1.254-1.25a1.22 1.22 0 0 0-.336-.848c-.755-.811-2.167-2.03-2.167-6.027 0-3.035-2.128-5.465-4.998-6.06V3.25a1.25 1.25 0 1 0-2.498 0v.814c-2.87.596-4.998 3.026-4.998 6.061 0 3.996-1.412 5.216-2.167 6.027A1.22 1.22 0 0 0 3 17c.004.64.507 1.25 1.254 1.25zm-1.384-1.875H5.638c.829-1.093 1.735-2.903 1.74-6.227l-.003-.023a4.375 4.375 0 1 1 8.75 0l-.002.023c.004 3.324.91 5.135 1.74 6.227M11.75 22a2.5 2.5 0 0 0 2.499-2.5H9.25A2.5 2.5 0 0 0 11.75 22",
    clipRule: "evenodd"
  })));
};
export default SvgBell;